module.exports = __webpack_public_path__ + "assets/app-store-apple.75fe4a4d.svg";